import {handleActions} from 'redux-actions';
import actions from './profileCoupons.actions';
import uuidv4 from 'uuid/v4';

const reducer = handleActions(
	{
		[actions.profileCouponListing]: (state, {payload}) => ({
			...state,
			coupons: [...payload.coupons]
		}),
		[actions.profileCouponDeleted]: (state, {payload}) => ({
			...state,
			coupons: state.coupons.filter(coupon => {
				return coupon.uuid !== payload.couponUuid;
			})
		}),
		[actions.profileWalletListing]: (state, {payload}) => ({
			...state,
			couponWallet: [...payload.coupons]
		}),
		[actions.profileCouponUpdated]: (state = {}, {payload}) => {
			return {
				...state,
				coupons: state.coupons.map(coupon => {
					// update coupon details in state as well
					if (coupon.uuid === payload.uuid) {
						coupon.description = payload.description;
						coupon.expiryDate = payload.expiryDate;
						coupon.quantity = payload.quantity;
					}
					return coupon;
				})
			};
		},
		[actions.profileCouponAdded]: (state, {payload}) => ({
			...state,
			coupons: state.coupons ? [payload.newCoupon[0], ...state.coupons] : []
		})
	},
	{}
);

export default reducer;



// WEBPACK FOOTER //
// ./src/profile/coupons/profileCoupons.reducer.js